import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import Button from "../../../../components/Button";
import Table from "../../../../components/table";
import { Accordion, Modal } from "react-bootstrap";
import api from "../../../../api/api";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Select from "react-select";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SelectField from "../../../../components/SelectField";

// Mock Data structure based on Screenshot Fields
const INITIAL_VENDOR_TEMPLATE = {
  id: "PUR-NEW",
  vendor_name: "",
  vendor_location: "",
  gst_number: "",
  pan_number: "",
  voucher_invoice_number: "",
  vendor_invoice_date: "",
  vb_number: "",
  vendor_job_number: "",
  master_shipper: "",
  master_consignee: "",
  master_bl_number: "",
  vessel_name: "",
  vessel_number: "",
  voyage_number: "",
  estimated_date: "",
  cut_off_date: "",
  items: [
    {
      charge_code: "",
      sac_code: "",
      currency: "INR",
      rate: "",
      quantity: "",
      taxable_amount: "",
      gst_applicable: "Yes",
      gst_percent: "",
      gst_amount: "",
      containers: "",
    },
  ],
};

const STATIC_PURCHASES_DATA = [
  {
    id: "PUR-101",
    vendor_name: "ABC Logistics Ltd.",
    vendor_location: "Mumbai, MH",
    gst_number: "27AAAAA0000A1Z5",
    pan_number: "AAAAA0000A",
    voucher_invoice_number: "98765",
    vendor_invoice_date: "2026-07-20",
    vb_number: "55412",
    vendor_job_number: "2024-001",
    master_shipper: "Global Exports",
    master_consignee: "Pacific Trade Inc",
    master_bl_number: "MBL-887123",
    vessel_name: "EVER GIVEN",
    vessel_number: "V-901",
    voyage_number: "VY-441",
    estimated_date: "2026-08-01",
    cut_off_date: "2026-07-29",
    items: [
      {
        charge_code: "Ocean Freight",
        sac_code: "996511",
        currency: "INR",
        rate: "40000",
        quantity: "1",
        taxable_amount: "40000",
        gst_applicable: "Yes",
        gst_percent: "18",
        gst_amount: "7200",
        containers: "TNCU1234567",
      },
    ],
  },
  {
    id: "PUR-102",
    vendor_name: "Global Freight Carriers",
    vendor_location: "Delhi, DL",
    gst_number: "07BBBBB1111B1Z2",
    pan_number: "BBBBB1111B",
    voucher_invoice_number: "11223",
    vendor_invoice_date: "2026-07-22",
    vb_number: "88901",
    vendor_job_number: "2024-089",
    master_shipper: "Alpha Traders",
    master_consignee: "Beta Logistics",
    master_bl_number: "MBL-99021",
    vessel_name: "MAERSK PEARL",
    vessel_number: "V-102",
    voyage_number: "VY-112",
    estimated_date: "2026-08-05",
    cut_off_date: "2026-08-02",
    items: [
      {
        charge_code: "Handling Fee",
        sac_code: "996719",
        currency: "INR",
        rate: "15000",
        quantity: "1",
        taxable_amount: "15000",
        gst_applicable: "Yes",
        gst_percent: "18",
        gst_amount: "2700",
        containers: "GESU9876543",
      },
    ],
  },
];

const Commercial = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [enquiry, setEnquiry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [postingToTally, setPostingToTally] = useState(false);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [vendorInvoiceDates, setVendorInvoiceDates] = useState([]);
  const [containerTableData, setContainerTableData] = useState([]);

  // Array state to allow multiple vendor accordion forms simultaneously
  const [selectedVendorIndices, setSelectedVendorIndices] = useState([]);
  const [activeKeys, setActiveKeys] = useState(["0", "1"]);

  const [showSaveAllModal, setShowSaveAllModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [errors, setErrors] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [loadingPurchase, setLoadingPurchase] = useState(false);
  const [existingPurchaseId, setExistingPurchaseId] = useState(null);

  const [chargeCodeOptions, setChargeCodeOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [loadingCurrencies, setLoadingCurrencies] = useState(false);
  const [loadingChargeCodes, setLoadingChargeCodes] = useState(false);

  const [formData, setFormData] = useState({
    job_number: "",
    po_number: "",
    actual_shipper: "",
    actual_consignee: "",
    house_bl_number: "",
    container_type: "",
    gross_wt: "",
    packaging: "",
    purchase_invoice_number: "",
    voucher_invoice_number: "",
    voucher_invoice_date: "",
    purchase_invoice_date: "",
    vendor_name: "",
    vendor_location: "",
    shipper: "",
    consignee: "",
    vessel_name: "",
    vessel_number: "",
    voyage_number: "",
    mbl_number: "",
    vb_number: "",
    vendor_job_number: "",
    container_number: "",
    etd_date: "",
    gst_number: "",
    pan_number: "",
    inv_number: "",
    invoice_date: "",
    billing_party: "",
    pol: "",
    pod: "",
    number_of_packages: "",
    notify_party: "",
    cut_off_date: "",
    shipment_segment: "",
    incoterms: "",
    freight_terms: "",
    container_count: 0,
  });
  const getEmptyVendorBlock = () => ({
    vendor_id: null,
    vendor_name: "",
    vendor_location: "",
    gst_number: "",
    pan_number: "",
    voucher_invoice_number: "",
    voucher_invoice_date: "",
    vb_number: "",
    vendor_job_number: "",
    shipper: "",
    consignee: "",
    mbl_number: "",
    vessel_name: "",
    vessel_number: "",
    voyage_number: "",
    etd_date: "",
    cut_off_date: "",
    inputChargeRow: { ...chargeRowDefault },
    chargeRows: [],
  });
  const chargeRowDefault = {
    charge_code: "",
    sac_code: "",
    currency: "",
    rate: "",
    quantity: "",
    taxable_amount: "",
    gst: "",
    gst_amount: "",
    gst_applicable: "Yes",
    applicableContainers: [], // array of container_id(s) this charge is entered against
  };
  const DatePickerField = ({ selected, onChange, placeholder, error }) => (
    <div style={{ position: "relative", width: "100%" }}>
      <DatePicker
        selected={selected}
        onChange={onChange}
        dateFormat="dd/MM/yyyy"
        wrapperClassName="w-100"
        className={`form-control w-100 ${error ? "is-invalid" : ""}`}
        placeholderText="DD/MM/YYYY"
        calendarClassName="custom-calendar"
      />
      <CalendarMonthIcon
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
          color: "#6c757d",
        }}
      />
    </div>
  );
  const containerOptions = containerTableData.map((c, i) => ({
    value: c.container_id ?? i,
    label: c.container_number
      ? `${c.container_number}${c.container_type ? " (" + c.container_type + ")" : ""}`
      : `Container ${i + 1}${c.container_type ? " (" + c.container_type + ")" : ""}`,
  }));
  console.log("containerOptions", containerOptions);
  console.log("containerTableData", containerTableData);
  const handleContainerChange = (index, field, value) => {
    setContainerTableData((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };
  const deleteChargeRow = (vendorIndex, index) => {
    setVendors((prev) => {
      const updated = [...prev];
      updated[vendorIndex].chargeRows = updated[vendorIndex].chargeRows.filter(
        (_, i) => i !== index,
      );
      return updated;
    });
  };
  const addChargeRow = (vendorId) => {
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;
        const { inputChargeRow } = v;
        if (!inputChargeRow.charge_code || !inputChargeRow.currency) {
          setErrors((prevErr) => ({
            ...prevErr,
            chargeTable: `Vendor ${
              prev.findIndex((x) => x.id === vendorId) + 1
            }: Please fill Charge Code and Currency before adding a new row`,
          }));
          return v;
        }

        setErrors((prevErr) => ({ ...prevErr, chargeTable: "" }));

        return {
          ...v,
          chargeRows: [...v.chargeRows, { ...inputChargeRow }],
          inputChargeRow: { ...chargeRowDefault },
        };
      }),
    );
  };
  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        setLoadingCurrencies(true);
        const response = await api.get("/exchange_rate");

        const formatted = response.data.map((item) => ({
          value: item.country_code,
          label: item.country_code,
        }));

        setCurrencyOptions(formatted);
      } catch (err) {
        console.error("Failed to fetch exchange rates:", err);
      } finally {
        setLoadingCurrencies(false);
      }
    };

    fetchExchangeRates();
  }, []);

  useEffect(() => {
    const fetchChargeCodes = async () => {
      try {
        setLoadingChargeCodes(true);
        const response = await api.get("/charge_code/options");

        setChargeCodeOptions(response.data);
      } catch (err) {
        console.error("Failed to fetch charge codes:", err);
      } finally {
        setLoadingChargeCodes(false);
      }
    };

    fetchChargeCodes();
  }, []);
  const fetchGSTForChargeCode = async (charge_code, vendorId, index) => {
    if (!charge_code) return;

    try {
      const response = await api.get(`/charge_code/gst/${charge_code}`);
      const gstPercentage = response.data.tax_percentage || 0;

      if (index === "input") {
        setVendors((prev) =>
          prev.map((v) => {
            if (v.id !== vendorId) return v;
            const updatedInput = { ...v.inputChargeRow, gst: gstPercentage };
            const amt = parseFloat(updatedInput.taxable_amount) || 0;
            const qty = parseFloat(updatedInput.quantity) || 0;
            const exchange = parseFloat(updatedInput.exchange_rate) || 1;

            const taxAmount = amt * qty * exchange;
            const gstAmount = (taxAmount * gstPercentage) / 100;
            const total = taxAmount + gstAmount;

            updatedInput.tax = Number(taxAmount.toFixed(2));
            updatedInput.gst_amount = Number(gstAmount.toFixed(2));
            updatedInput.cgst = Number((gstAmount / 2).toFixed(2));
            updatedInput.sgst = Number((gstAmount / 2).toFixed(2));
            updatedInput.total = Number(total.toFixed(2));

            return { ...v, inputChargeRow: updatedInput };
          }),
        );
      } else {
        setVendors((prev) =>
          prev.map((v) => {
            if (v.id !== vendorId) return v;
            const updated = [...v.chargeRows];
            updated[index].gst = gstPercentage;

            const amount = parseFloat(updated[index].taxable_amount) || 0;
            const qty = parseFloat(updated[index].quantity) || 0;
            const exchange = parseFloat(updated[index].exchange_rate) || 1;

            const taxAmount = amount * qty * exchange;
            const gstAmount = (taxAmount * gstPercentage) / 100;
            const total = taxAmount + gstAmount;

            updated[index].gst_amount = Number(gstAmount.toFixed(2));
            updated[index].cgst = Number((gstAmount / 2).toFixed(2));
            updated[index].sgst = Number((gstAmount / 2).toFixed(2));
            updated[index].tax = Number(taxAmount.toFixed(2));
            updated[index].total = Number(total.toFixed(2));

            return { ...v, chargeRows: updated };
          }),
        );
      }
    } catch (err) {
      console.error("Failed to fetch GST for charge code:", err);
    }
  };
  const removeVendor = (vendorId) => {
    setVendors((prev) => prev.filter((v) => v.id !== vendorId));
  };

  const addVendor = () => {
    setVendors((prev) => [
      ...prev,
      { ...getEmptyVendorBlock(), id: Date.now() },
    ]);
  };
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        setLoadingVendors(true);
        const response = await api.get("/master-data/vendor-master");
        const vendors = (response.data.vendors || []).map((v) => ({
          value: v.vendor_id,
          label: v.name,
          ...v,
        }));
        setVendorOptions(vendors);
      } catch (err) {
        console.error("Failed to fetch vendors:", err);
      } finally {
        setLoadingVendors(false);
      }
    };

    fetchVendors();
  }, []);

  const vendorEntries = vendors.map((v) => ({
    vendor_id: v.vendor_id,
    vendor_name: v.vendor_name,
    vendor_location: v.vendor_location,
    gst_number: v.gst_number,
    pan_number: v.pan_number,
    voucher_invoice_number: v.voucher_invoice_number,
    voucher_invoice_date: v.voucher_invoice_date,
    vb_number: v.vb_number,
    vendor_job_number: v.vendor_job_number,
    shipper: v.shipper,
    consignee: v.consignee,
    mbl_number: v.mbl_number,
    vessel_name: v.vessel_name,
    vessel_number: v.vessel_number,
    voyage_number: v.voyage_number,
    etd_date: v.etd_date,
    cut_off_date: v.cut_off_date,
    vendor_total: Number(
      v.chargeRows
        .reduce((sum, c) => sum + (Number(c.amount_in_inr) || 0), 0)
        .toFixed(2),
    ),
    charges: v.chargeRows.map((c) => ({
      charge_code: c.charge_code,
      sac_code: c.sac_code,
      currency: c.currency,
      exchange_rate: c.exchange_rate,
      rate: c.rate,
      quantity: c.quantity,
      taxable_amount: c.taxable_amount,
      amount_in_inr: c.amount_in_inr,
      gst_applicable: c.gst_applicable || "Yes",
      gst_percentage: c.gst,
      gst_amount: c.gst_amount,
      cgst: c.cgst,
      sgst: c.sgst,
      container_ids: c.applicableContainers || [],
    })),
  }));

  const handleSaveAllPurchases = async () => {
    try {
      setSaving(true);

      console.log("Saving all purchases to Tally...");

      // Confirmation modal close
      setShowSaveAllModal(false);

      // Success modal open
      setShowSuccessModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setSaving(false);
    }
  };
  const updateVendor = (vendorId, field, value) => {
    setVendors((prev) =>
      prev.map((v) => (v.id === vendorId ? { ...v, [field]: value } : v)),
    );
  };

  const updateVendorInputCharge = (vendorId, field, value) => {
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;
        const updatedInput = { ...v.inputChargeRow, [field]: value };
        if (field === "gst_applicable" && value === "No") {
          updatedInput.gst = "0";
          updatedInput.gst_amount = "0";
        }
        if (field === "rate" || field === "quantity") {
          const rate =
            field === "rate" ? Number(value) : Number(updatedInput.rate || 0);
          const quantity =
            field === "quantity"
              ? Number(value)
              : Number(updatedInput.quantity || 0);
          updatedInput.taxable_amount = (rate * quantity).toString();
        }
        if (
          field === "rate" ||
          field === "quantity" ||
          field === "exchange_rate" ||
          field === "currency"
        ) {
          const taxable = Number(updatedInput.taxable_amount) || 0;
          const exchange = Number(updatedInput.exchange_rate) || 1;
          updatedInput.amount_in_inr = Number((taxable * exchange).toFixed(2));
        }
        return { ...v, inputChargeRow: updatedInput };
      }),
    );
  };

  const handleCurrencyChange = async (vendorId, index, selectedCurrency) => {
    const country_code = selectedCurrency?.value || "";
    if (index === "input") {
      updateVendorInputCharge(vendorId, "currency", country_code);
    } else {
      handleVendorChargeInputChange(vendorId, index, "currency", country_code);
    }

    if (!country_code) {
      if (index === "input") {
        updateVendorInputCharge(vendorId, "exchange_rate", "");
      } else {
        handleVendorChargeInputChange(vendorId, index, "exchange_rate", "");
      }
      return;
    }

    try {
      const res = await api.get(`/exchange_rate/rate/${country_code}`);
      if (index === "input") {
        updateVendorInputCharge(
          vendorId,
          "exchange_rate",
          Number(res.data.rate_in_INR),
        );
      } else {
        handleVendorChargeInputChange(
          vendorId,
          index,
          "exchange_rate",
          Number(res.data.rate_in_INR),
        );
      }
    } catch (err) {
      console.error("Failed to fetch exchange rate:", err);
      if (index === "input") {
        updateVendorInputCharge(vendorId, "exchange_rate", "N/A");
      } else {
        handleVendorChargeInputChange(vendorId, index, "exchange_rate", "N/A");
      }
    }
  };

  const handleVendorChargeInputChange = (vendorId, index, field, value) => {
    setVendors((prev) =>
      prev.map((v) => {
        if (v.id !== vendorId) return v;
        const updated = [...v.chargeRows];
        updated[index] = { ...updated[index], [field]: value };
        if (field === "gst_applicable" && value === "No") {
          updated[index].gst = "0";
          updated[index].gst_amount = "0";
        }
        if (field === "rate" || field === "quantity") {
          const rate =
            field === "rate" ? Number(value) : Number(updated[index].rate || 0);
          const quantity =
            field === "quantity"
              ? Number(value)
              : Number(updated[index].quantity || 0);
          updated[index].taxable_amount = (rate * quantity).toString();
        }
        if (
          field === "rate" ||
          field === "quantity" ||
          field === "exchange_rate" ||
          field === "currency"
        ) {
          const taxable = Number(updated[index].taxable_amount) || 0;
          const exchange = Number(updated[index].exchange_rate) || 1;
          updated[index].amount_in_inr = Number(
            (taxable * exchange).toFixed(2),
          );
        }
        return { ...v, chargeRows: updated };
      }),
    );
  };

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const allowedEditors = ["GFR003", "GFR009", "wMe2inT9YF9i"];
  const canEdit = allowedEditors.includes(user?.user_id);
  const isAdminOrSuperAdmin = ["admin", "superadmin", "GFR003"].includes(
    user?.role || user?.user_id,
  );
  const handleVendorSelect = (selectedVendor, vendorId) => {
    if (!selectedVendor) {
      updateVendor(vendorId, "vendor_id", null);
      updateVendor(vendorId, "vendor_name", "");
      updateVendor(vendorId, "vendor_location", "");
      updateVendor(vendorId, "gst_number", "");
      updateVendor(vendorId, "pan_number", "");
      return;
    }

    updateVendor(vendorId, "vendor_id", selectedVendor.vendor_id);
    updateVendor(vendorId, "vendor_name", selectedVendor.name || "");
    updateVendor(vendorId, "vendor_location", selectedVendor.location || "");
    updateVendor(vendorId, "gst_number", selectedVendor.gst_number || "");
    updateVendor(vendorId, "pan_number", selectedVendor.pan_number || "");
  };
  const fetchEnquiry = async (enqId) => {
    try {
      const response = await api.get(
        `/master-data/container-status-report/${id}`,
      );
      console.log("response.data", response.data);
      // console.log(response.data.enquiry);
      const enquiry = response.data.enquiry;

      setEnquiry(enquiry);
      setContainerTableData(
        enquiry.containerDetails?.map((c, i) => ({
          container_id: c.container_id ?? i,
          container_type: c.container_type,
          container_number: c.container_number || "",
          seal_number: c.seal_number || "",
          container_weight: c.container_weight,
          container_length: c.container_length,
          container_breadth: c.container_breadth,
          container_height: c.container_height,
          container_temperature: c.container_temperature,
        })) || [],
      );
      if (id === "new") {
        try {
          const entriesRes = await api.get(`/purchase/by-enquiry/${enqId}`);
          const entries = entriesRes.data.entries || [];
          if (entries.length > 0) {
            const latestPurchaseId = entries[0].purchase_invoice_id;
            const purchaseRes = await api.get(`/purchase/${latestPurchaseId}`);
            const purchase = purchaseRes.data;
            console.log("purchase", purchase);
            if (purchase && purchase.success) {
              const loadedVendors = (purchase.vendorEntries || []).map((v) => ({
                vendor_id: v.vendor_id,
                vendor_name: v.vendor_name || "",
                vendor_location: v.vendor_location || "",
                vendor_total: v.vendor_total ?? 0,
                gst_number: v.party_gstin || "",
                pan_number: v.pan_number || "",
                voucher_invoice_number: v.voucher_invoice_number || "",
                voucher_invoice_date: v.voucher_invoice_date || "",
                vb_number: v.vb_number || "",
                vendor_job_number: v.vendor_job_number || "",
                shipper: v.shipper || "",
                consignee: v.consignee || "",
                mbl_number: v.mbl_number || "",
                vessel_name: v.vessel_name || "",
                vessel_number: v.vessel_number || "",
                voyage_number: v.voyage_number || "",
                etd_date: v.etd_date || "",
                cut_off_date: v.cut_off_date || "",
                inputChargeRow: { ...chargeRowDefault },
                chargeRows: (v.charges || []).map((c) => ({
                  charge_code: c.charge_code || "",
                  sac_code: c.sac_code || "",
                  currency: c.currency || "",
                  exchange_rate: c.exchange_rate || "",
                  rate: c.rate || "",
                  quantity: c.quantity || "",
                  taxable_amount: c.taxable_amount || "",
                  amount_in_inr: c.amount_in_inr || "",
                  gst: c.gst_percentage || "",
                  gst_amount: c.gst_amount || "",
                  cgst: c.cgst || "",
                  sgst: c.sgst || "",
                  gst_applicable: c.gst_applicable || "Yes",
                  applicableContainers: c.applicableContainers || [],
                })),
              }));
              setVendors(loadedVendors);
            }
          }
        } catch (err) {
          console.error(
            "Failed to pre-populate vendors from existing purchase:",
            err,
          );
        }
      }
    } catch (error) {
      console.error("Error fetching enquiry:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log("vender", vendors);
  useEffect(() => {
    fetchEnquiry(id);
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: enquiry
      ? {
          ...enquiry,
          sales_invoice_no: enquiry.sales_invoice_no || "",
          sales_amount: enquiry.sales_amount || 0,
          sales_currency: enquiry.sales_currency || "INR",
          sales_remarks: enquiry.sales_remarks || "",
          purchases:
            enquiry.purchases && enquiry.purchases.length > 0
              ? enquiry.purchases
              : STATIC_PURCHASES_DATA,
        }
      : {
          sales_invoice_no: "",
          sales_amount: 0,
          sales_currency: "INR",
          sales_remarks: "",
          purchases: STATIC_PURCHASES_DATA,
        },
    onSubmit: () => {
      setShowConfirm(true);
    },
  });

  // Calculate Totals
  const totalSales = Number(formik.values.sales_amount) || 0;
  const totalPurchase =
    formik.values.purchases?.reduce((acc, curr) => {
      const itemTotal = curr.items?.reduce(
        (iAcc, item) => iAcc + (Number(item.taxable_amount) || 0),
        0,
      );
      return acc + (itemTotal || Number(curr.amount) || 0);
    }, 0) || 0;
  const netProfitLoss = totalSales - totalPurchase;

  // Toggle selection helper - Opens and Closes on Row Click
  const handleSelectVendor = (index) => {
    const key = `vendor-${index}`;

    setSelectedVendorIndices((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );

    setActiveKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  // Handlers for Vendor Forms
  const handleAddVendor = () => {
    const newPurchases = [
      ...formik.values.purchases,
      { ...INITIAL_VENDOR_TEMPLATE, id: `PUR-${Date.now()}` },
    ];
    const newIndex = newPurchases.length - 1;
    formik.setFieldValue("purchases", newPurchases);
    setSelectedVendorIndices((prev) => [...prev, newIndex]);
  };

  const handleRemoveVendor = (index) => {
    const updated = [...formik.values.purchases];
    updated.splice(index, 1);
    formik.setFieldValue("purchases", updated);

    // Filter out removed index & readjust remaining indices
    setSelectedVendorIndices((prev) =>
      prev.filter((i) => i !== index).map((i) => (i > index ? i - 1 : i)),
    );
  };

  const handleAddItemRow = (vendorIdx) => {
    const updated = [...formik.values.purchases];
    updated[vendorIdx].items.push({
      charge_code: "",
      sac_code: "",
      currency: "INR",
      rate: "",
      quantity: "",
      taxable_amount: "",
      gst_applicable: "Yes",
      gst_percent: "",
      gst_amount: "",
      containers: "",
    });
    formik.setFieldValue("purchases", updated);
  };

  const handleRemoveItemRow = (vendorIdx, itemIdx) => {
    const updated = [...formik.values.purchases];
    updated[vendorIdx].items.splice(itemIdx, 1);
    formik.setFieldValue("purchases", updated);
  };

  const handlePostToTally = async (e, rowData) => {
    e.stopPropagation();
    setPostingToTally(true);
    try {
      await api.post("/tally/post-purchase", {
        purchase_data: rowData,
        enquiry_id: id,
      });
      alert("Successfully posted to Tally!");
      const updatedPurchases = formik.values.purchases.map((p) =>
        p.id === rowData.id ? { ...p, status: "Posted" } : p,
      );
      formik.setFieldValue("purchases", updatedPurchases);
    } catch (err) {
      console.error("Error posting to Tally:", err);
      alert("Failed to post data to Tally.");
    } finally {
      setPostingToTally(false);
    }
  };

  const handleConfirm = async () => {
    setLoadingSubmit(true);
    try {
      setShowConfirm(false);
      await api.put(`/master-data/container-status-report`, {
        ...formik.values,
        enquiry_id: id,
      });
      setSuccessMessage("Commercial details updated successfully!");
      setShowSuccess(true);
    } catch (error) {
      console.error("Error updating commercial data:", error);
      alert("Failed to update commercial data.");
    } finally {
      setLoadingSubmit(false);
    }
  };

  const purchaseColumns = [
    {
      label: "S.No.",
      render: (_, index) => index + 1,
    },
    {
      label: "Vendor Name",
      render: (row, idx) => (
        <span
          // className="text-primary fw-semibold cursor-pointer"
          // onClick={() => handleSelectVendor(idx)}
          title="Click to view/hide vendor details form"
        >
          {row.vendor_name || `Vendor ${idx + 1}`}
        </span>
      ),
    },
    {
      label: "Vendor Job No.",
      accessor: "vendor_job_number",
    },
    {
      label: "Vendor Invoice No.",
      render: (row) => row.voucher_invoice_number || row.invoice_no || "N/A",
    },
    {
      label: "Booking No.",
      render: (row) => row.vb_number || row.booking_no || "N/A",
    },
    ...(isAdminOrSuperAdmin
      ? [
          {
            label: "Tally Post",
            render: (row) => (
              <Button
                variant="outline-success"
                size="sm"
                disabled={postingToTally || row.status === "Posted"}
                onClick={(e) => handlePostToTally(e, row)}
              >
                <SendIcon fontSize="small" /> Post
              </Button>
            ),
          },
        ]
      : []),
  ];

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Breadcrumbs />

      <form onSubmit={formik.handleSubmit}>
        <Accordion
          activeKey={activeKeys}
          alwaysOpen
          onSelect={(eventKeys) => {
            setActiveKeys(eventKeys || []);
          }}
          className="customaccordion mb-4"
        >
          {/* SECTION 1: SALES */}
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <span className="fw-bold text-black">Sales Details</span>
            </Accordion.Header>
            <Accordion.Body>
              <div className="row g-3">
                <div className="col-md-3">
                  <InputField
                    label="Sales Invoice No."
                    name="sales_invoice_no"
                    value={formik.values.sales_invoice_no}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>
                <div className="col-md-3">
                  <InputField
                    label="Sales Amount"
                    type="number"
                    name="sales_amount"
                    value={formik.values.sales_amount}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>
                <div className="col-md-3">
                  <InputField
                    label="Currency"
                    name="sales_currency"
                    value={formik.values.sales_currency}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>
                <div className="col-md-3">
                  <InputField
                    label="Sales Remarks / Notes"
                    name="sales_remarks"
                    value={formik.values.sales_remarks}
                    onChange={formik.handleChange}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          {/* SECTION 2: ALL PURCHASES LIST TABLE  */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <span className="fw-bold text-black">
                All Purchases (Vendor Invoices)
              </span>
              <div className="d-flex justify-content-end gap-3">
                <Button
                  variant="success"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSaveAllModal(true);
                  }}
                >
                  Save All Purchases
                </Button>
                  <Button
                  variant="contained"
                  btncls="bg-darkblue text-white px-4 py-2 vendor-add-btn"
                  onClick={addVendor}
                  onClick={(e) => {
           e.stopPropagation();
          addVendor();
         }}
                  startIcon={<AddCircleOutlineIcon />}
                  children="Add New Vendor"
                />
 
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <Table
                columns={purchaseColumns}
                data={formik.values.purchases}
                onRowClick={(_, index) => handleSelectVendor(index)}
                emptyMessage='No purchase records found. Click "Add Purchase" to add one.'
              />
            </Accordion.Body>
            {vendors.length === 0
              ? null
              : vendors.map((vendor, vendorIndex) => {
                  const vendorTotal =
                    vendor.vendor_total != null && vendor.vendor_total !== ""
                      ? Number(vendor.vendor_total)
                      : vendor.chargeRows.reduce(
                          (sum, c) => sum + (Number(c.amount_in_inr) || 0),
                          0,
                        );
                  return (
                    <div
                      key={vendor.id}
                      className="vendor-section mb-5"
                      style={{
                        border: "1px solid #dee2e6",
                        borderRadius: 8,
                        padding: 20,
                        overflow: "visible",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0 border-bottom pb-2">
                          As Per Vendor {vendorIndex + 1}
                        </h5>
                        {vendors.length > 0 && (
                          <Button
                            variant="contained"
                            btncls="bg-danger text-white px-3 py-1 vendor-remove-btn"
                            size="small"
                            onClick={() => removeVendor(vendor.id)}
                          >
                            Remove
                          </Button>
                        )}
                      </div>

                      <div className="row g-3 mb-4">
                        <div className="col-md-4">
                          <label className="form-label">Vendor Name</label>
                          <Select
                            options={vendorOptions}
                            value={
                              vendorOptions.find(
                                (v) => v.value === vendor.vendor_id,
                              ) ||
                              (vendor.vendor_id
                                ? {
                                    value: vendor.vendor_id,
                                    label: vendor.vendor_name,
                                  }
                                : null)
                            }
                            onChange={(selected) =>
                              handleVendorSelect(selected, vendor.id)
                            }
                            placeholder="Select Vendor"
                            isLoading={loadingVendors}
                            isClearable
                          />
                        </div>
                      
                        <div className="col-md-4">
                          <InputField
                            label="Vendor Location"
                            value={vendor.vendor_location}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "vendor_location",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Vendor Location"
                          />
                        </div>
                        
                        <div className="col-md-4">
                          <InputField
                            label="GST Number"
                            value={vendor.gst_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "gst_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter GST Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="PAN Number"
                            value={vendor.pan_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "pan_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter PAN Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Vendor Invoice Number"
                            value={vendor.voucher_invoice_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "voucher_invoice_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Vendor Invoice Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Vendor Invoice Date
                          </label>
                          <DatePickerField
                            selected={vendorInvoiceDates[vendorIndex] || null}
                            onChange={(date) => {
                              const newDates = [...vendorInvoiceDates];
                              newDates[vendorIndex] = date;
                              setVendorInvoiceDates(newDates);
                              updateVendor(
                                vendor.id,
                                "voucher_invoice_date",
                                date,
                              );
                            }}
                            placeholder="DD/MM/YYYY"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Vendor Booking Number"
                            value={vendor.vb_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "vb_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Vendor Booking Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Vendor Job Number"
                            value={vendor.vendor_job_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "vendor_job_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Vendor Job Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Master Shipper"
                            value={vendor.shipper}
                            onChange={(e) =>
                              updateVendor(vendor.id, "shipper", e.target.value)
                            }
                            placeholder="Enter Master Shipper"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Master Consignee"
                            value={vendor.consignee}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "consignee",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Master Consignee"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Master BL Number"
                            value={vendor.mbl_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "mbl_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Master BL Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Vessel Name"
                            value={vendor.vessel_name}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "vessel_name",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Vessel Name"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Vessel Number"
                            value={vendor.vessel_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "vessel_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Vessel Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Voyage Number"
                            value={vendor.voyage_number}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "voyage_number",
                                e.target.value,
                              )
                            }
                            placeholder="Enter Voyage Number"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Estimated Date"
                            name="etd_date"
                            type="date"
                            value={vendor.etd_date}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "etd_date",
                                e.target.value,
                              )
                            }
                          />
                        </div>
                        <div className="col-md-4">
                          <InputField
                            label="Cut Off Date"
                            name="cut_off_date"
                            type="date"
                            value={vendor.cut_off_date || ""}
                            onChange={(e) =>
                              updateVendor(
                                vendor.id,
                                "cut_off_date",
                                e.target.value,
                              )
                            }
                          />
                        </div>
                      </div>

                      <div
                        className="mb-4 position-relative"
                        style={{ maxHeight: "100%" }}
                      >
                        <table className="table table-bordered tbllbl mb-2 mb-md-3">
                          <thead className="table-light">
                            <tr>
                              <th>Charge Code</th>
                              <th>SAC Code</th>
                              <th>Currency</th>
                              <th>Rate</th>
                              <th>Quantity</th>
                              <th>Taxable Amount</th>
                              <th>GST Applicable</th>
                              <th>GST %</th>
                              <th>GST Amount</th>
                              <th>Container(s)</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <SelectField
                                  options={chargeCodeOptions}
                                  value={vendor.inputChargeRow.charge_code}
                                  onChange={(val) => {
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "charge_code",
                                      val,
                                    );
                                  }}
                                  isLoading={loadingChargeCodes}
                                  searchable
                                />
                              </td>
                              <td>
                                <InputField
                                  type="text"
                                  placeholder="SAC Code"
                                  value={vendor.inputChargeRow.sac_code || ""}
                                  onChange={(e) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "sac_code",
                                      e.target.value,
                                    )
                                  }
                                />
                              </td>
                              <td className="minselect">
                                <Select
                                  options={currencyOptions}
                                  value={
                                    currencyOptions.find(
                                      (c) =>
                                        c.value ===
                                        vendor.inputChargeRow.currency,
                                    ) || null
                                  }
                                  onChange={(selected) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "currency",
                                      selected?.value || "",
                                    )
                                  }
                                  isLoading={loadingCurrencies}
                                  placeholder="Select"
                                />
                              </td>
                              <td>
                                <InputField
                                  type="text"
                                  placeholder="Rate"
                                  value={vendor.inputChargeRow.rate || ""}
                                  onChange={(e) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "rate",
                                      e.target.value,
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <InputField
                                  type="text"
                                  placeholder="Quantity"
                                  value={vendor.inputChargeRow.quantity || ""}
                                  onChange={(e) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "quantity",
                                      e.target.value,
                                    )
                                  }
                                />
                              </td>
                              <td>
                                <InputField
                                  type="text"
                                  placeholder="Amount"
                                  value={
                                    vendor.inputChargeRow.taxable_amount || ""
                                  }
                                  onChange={(e) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "taxable_amount",
                                      e.target.value,
                                    )
                                  }
                                />
                              </td>
                              <td className="minselect">
                                <Select
                                  options={[
                                    { label: "Yes", value: "Yes" },
                                    { label: "No", value: "No" },
                                  ]}
                                  value={
                                    vendor.inputChargeRow.gst_applicable ===
                                    "No"
                                      ? { label: "No", value: "No" }
                                      : { label: "Yes", value: "Yes" }
                                  }
                                  onChange={(selected) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "gst_applicable",
                                      selected?.value || "Yes",
                                    )
                                  }
                                  placeholder="Select"
                                />
                              </td>
                              <td>
                                <InputField
                                  type="text"
                                  placeholder="GST %"
                                  value={vendor.inputChargeRow.gst || ""}
                                  onChange={(e) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "gst",
                                      e.target.value,
                                    )
                                  }
                                  disabled={
                                    vendor.inputChargeRow.gst_applicable ===
                                    "No"
                                  }
                                />
                              </td>
                              <td>
                                <InputField
                                  type="text"
                                  placeholder="GST Amt"
                                  value={
                                    vendor.inputChargeRow.gst_applicable ===
                                    "No"
                                      ? "0"
                                      : vendor.inputChargeRow.gst_amount || ""
                                  }
                                  onChange={(e) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "gst_amount",
                                      e.target.value,
                                    )
                                  }
                                  disabled={
                                    vendor.inputChargeRow.gst_applicable ===
                                    "No"
                                  }
                                />
                              </td>
                              <td className="minselect">
                                <Select
                                  isMulti
                                  options={containerOptions}
                                  value={
                                    containerOptions.filter((o) =>
                                      (
                                        vendor.inputChargeRow
                                          .applicableContainers || []
                                      ).includes(o.value),
                                    ) || null
                                  }
                                  onChange={(selected) =>
                                    updateVendorInputCharge(
                                      vendor.id,
                                      "applicableContainers",
                                      (selected || []).map((s) => s.value),
                                    )
                                  }
                                  placeholder="Select Container(s)"
                                  isDisabled={containerOptions.length === 0}
                                />
                              </td>
                              <td className="text-center">
                                <AddCircleOutlineIcon
                                  style={{
                                    cursor: "pointer",
                                    color: "green",
                                    fontSize: 28,
                                  }}
                                  onClick={() => addChargeRow(vendor.id)}
                                />
                              </td>
                            </tr>
                            {vendor.chargeRows.map((charge, index) => (
                              <tr key={index}>
                                <td>
                                  <SelectField
                                    options={chargeCodeOptions}
                                    value={charge.charge_code}
                                    onChange={(val) => {
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "charge_code",
                                        val,
                                      );
                                      fetchGSTForChargeCode(
                                        val,
                                        vendor.id,
                                        index,
                                      );
                                    }}
                                    isLoading={loadingChargeCodes}
                                    searchable
                                  />
                                </td>
                                <td>
                                  <InputField
                                    type="text"
                                    value={charge.sac_code || ""}
                                    onChange={(e) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "sac_code",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                                <td className="minselect">
                                  <Select
                                    options={currencyOptions}
                                    value={
                                      currencyOptions.find(
                                        (c) => c.value === charge.currency,
                                      ) || null
                                    }
                                    onChange={(selected) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "currency",
                                        selected?.value || "",
                                      )
                                    }
                                    isLoading={loadingCurrencies}
                                  />
                                </td>
                                <td>
                                  <InputField
                                    type="text"
                                    value={charge.rate || ""}
                                    onChange={(e) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "rate",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <InputField
                                    type="text"
                                    value={charge.quantity || ""}
                                    onChange={(e) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "quantity",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <InputField
                                    type="text"
                                    value={charge.taxable_amount || ""}
                                    onChange={(e) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "taxable_amount",
                                        e.target.value,
                                      )
                                    }
                                  />
                                </td>
                                <td className="minselect">
                                  <Select
                                    options={[
                                      { label: "Yes", value: "Yes" },
                                      { label: "No", value: "No" },
                                    ]}
                                    value={
                                      charge.gst_applicable === "No"
                                        ? { label: "No", value: "No" }
                                        : { label: "Yes", value: "Yes" }
                                    }
                                    onChange={(selected) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "gst_applicable",
                                        selected?.value || "Yes",
                                      )
                                    }
                                    placeholder="Select"
                                  />
                                </td>
                                <td>
                                  <InputField
                                    type="text"
                                    value={charge.gst || ""}
                                    onChange={(e) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "gst",
                                        e.target.value,
                                      )
                                    }
                                    disabled={charge.gst_applicable === "No"}
                                  />
                                </td>
                                <td>
                                  <InputField
                                    type="text"
                                    value={
                                      charge.gst_applicable === "No"
                                        ? "0"
                                        : charge.gst_amount || ""
                                    }
                                    onChange={(e) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "gst_amount",
                                        e.target.value,
                                      )
                                    }
                                    disabled={charge.gst_applicable === "No"}
                                  />
                                </td>
                                <td className="minselect">
                                  <Select
                                    isMulti
                                    options={containerOptions}
                                    value={
                                      containerOptions.filter((o) =>
                                        (
                                          charge.applicableContainers || []
                                        ).includes(o.value),
                                      ) || null
                                    }
                                    onChange={(selected) =>
                                      handleVendorChargeInputChange(
                                        vendor.id,
                                        index,
                                        "applicableContainers",
                                        (selected || []).map((s) => s.value),
                                      )
                                    }
                                    placeholder="Select Container(s)"
                                    isDisabled={containerOptions.length === 0}
                                  />
                                </td>
                                <td className="text-center">
                                  <DeleteOutlineIcon
                                    style={{
                                      cursor: "pointer",
                                      color: "red",
                                      fontSize: 28,
                                    }}
                                    onClick={() =>
                                      deleteChargeRow(vendorIndex, index)
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {vendor.chargeRows.length > 0 && (
                          <div className="d-flex justify-content-end mt-2">
                            <strong>
                              Grand Total: {vendorTotal.toFixed(2)} INR
                            </strong>
                          </div>
                        )}
                        <div className="table-error text-danger mb-2">
                          {errors.vendorTable && vendorIndex === 0 && (
                            <span>{errors.vendorTable}</span>
                          )}
                          {errors[`vendor_${vendorIndex}_charges`] && (
                            <span>
                              {errors[`vendor_${vendorIndex}_charges`]}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
          </Accordion.Item>

          {/* SECTION 3: VENDOR PURCHASE DETAILS FORM SECTION */}
          {formik.values.purchases?.map((vendor, vendorIdx) => {
            // Check if vendor index is in selected list
            if (!selectedVendorIndices.includes(vendorIdx)) {
              return null;
            }

            return (
              <Accordion.Item
                eventKey={`vendor-${vendorIdx}`}
                key={vendor.id || vendorIdx}
              >
                <Accordion.Header>
                  <div className="d-flex justify-content-between align-items-center w-100 me-3">
                    <span className="fw-bold text-black">
                      As Per Vendor {vendorIdx + 1} (
                      {vendor.vendor_name || "New Vendor"})
                    </span>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold text-secondary m-0">
                      Purchase Invoice Details
                    </h6>
                    {canEdit && (
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemoveVendor(vendorIdx)}
                      >
                        Remove
                      </button>
                    )}
                  </div>

                  {/* VENDOR METADATA FORM FIELDS */}
                  <div className="row g-3">
                    <div className="col-md-4">
                      <InputField
                        label="Vendor Name"
                        name={`purchases[${vendorIdx}].vendor_name`}
                        value={formik.values.purchases[vendorIdx]?.vendor_name}
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Vendor Location"
                        name={`purchases[${vendorIdx}].vendor_location`}
                        value={
                          formik.values.purchases[vendorIdx]?.vendor_location
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="GST Number"
                        name={`purchases[${vendorIdx}].gst_number`}
                        value={formik.values.purchases[vendorIdx]?.gst_number}
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>

                    <div className="col-md-4">
                      <InputField
                        label="PAN Number"
                        name={`purchases[${vendorIdx}].pan_number`}
                        value={formik.values.purchases[vendorIdx]?.pan_number}
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Vendor Invoice Number"
                        name={`purchases[${vendorIdx}].voucher_invoice_number`}
                        value={
                          formik.values.purchases[vendorIdx]
                            ?.voucher_invoice_number
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Vendor Invoice Date"
                        type="date"
                        name={`purchases[${vendorIdx}].vendor_invoice_date`}
                        value={
                          formik.values.purchases[vendorIdx]
                            ?.vendor_invoice_date
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>

                    <div className="col-md-4">
                      <InputField
                        label="Vendor Booking Number"
                        name={`purchases[${vendorIdx}].vb_number`}
                        value={formik.values.purchases[vendorIdx]?.vb_number}
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Vendor Job Number"
                        name={`purchases[${vendorIdx}].vendor_job_number`}
                        value={
                          formik.values.purchases[vendorIdx]?.vendor_job_number
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Master Shipper"
                        name={`purchases[${vendorIdx}].master_shipper`}
                        value={
                          formik.values.purchases[vendorIdx]?.master_shipper
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>

                    <div className="col-md-4">
                      <InputField
                        label="Master Consignee"
                        name={`purchases[${vendorIdx}].master_consignee`}
                        value={
                          formik.values.purchases[vendorIdx]?.master_consignee
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Master BL Number"
                        name={`purchases[${vendorIdx}].master_bl_number`}
                        value={
                          formik.values.purchases[vendorIdx]?.master_bl_number
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Vessel Name"
                        name={`purchases[${vendorIdx}].vessel_name`}
                        value={formik.values.purchases[vendorIdx]?.vessel_name}
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>

                    <div className="col-md-4">
                      <InputField
                        label="Vessel Number"
                        name={`purchases[${vendorIdx}].vessel_number`}
                        value={
                          formik.values.purchases[vendorIdx]?.vessel_number
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Voyage Number"
                        name={`purchases[${vendorIdx}].voyage_number`}
                        value={
                          formik.values.purchases[vendorIdx]?.voyage_number
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                    <div className="col-md-4">
                      <InputField
                        label="Estimated Date"
                        type="date"
                        name={`purchases[${vendorIdx}].estimated_date`}
                        value={
                          formik.values.purchases[vendorIdx]?.estimated_date
                        }
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>

                    <div className="col-md-4">
                      <InputField
                        label="Cut Off Date"
                        type="date"
                        name={`purchases[${vendorIdx}].cut_off_date`}
                        value={formik.values.purchases[vendorIdx]?.cut_off_date}
                        onChange={formik.handleChange}
                        disabled={!canEdit}
                      />
                    </div>
                  </div>

                  {/* CHARGE BREAKDOWN TABLE */}
                  <div className="table-responsive mt-4">
                    <table className="table table-bordered align-middle text-center">
                      <thead className="table-light fs-7">
                        <tr>
                          <th>Charge Code</th>
                          <th>SAC Code</th>
                          <th>Currency</th>
                          <th>Rate</th>
                          <th>Quantity</th>
                          <th>Taxable Amount</th>
                          <th>GST Applicable</th>
                          <th>GST %</th>
                          <th>GST Amount</th>
                          <th>Container(s)</th>
                          {canEdit && <th>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {vendor.items?.map((item, itemIdx) => (
                          <tr key={itemIdx}>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].charge_code`}
                                value={item.charge_code}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].sac_code`}
                                value={item.sac_code}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].currency`}
                                value={item.currency}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              >
                                <option value="INR">INR</option>
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                              </select>
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].rate`}
                                value={item.rate}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                              
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].quantity`}
                                value={item.quantity}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].taxable_amount`}
                                value={item.taxable_amount}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                             
                            
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].gst_applicable`}
                                value={item.gst_applicable}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              >
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                               
                              </select>
                            </td>
                            
                            <td>
                              <input
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].gst_percent`}
                                value={item.gst_percent}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].gst_amount`}
                                value={item.gst_amount}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                name={`purchases[${vendorIdx}].items[${itemIdx}].containers`}
                                value={item.containers}
                                onChange={formik.handleChange}
                                disabled={!canEdit}
                              />
                            </td>
                            {canEdit && (
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-outline-danger btn-sm p-1"
                                  onClick={() =>
                                    handleRemoveItemRow(vendorIdx, itemIdx)
                                  }
                                >
                                  <DeleteOutlineIcon fontSize="small" />
                                </button>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            );
          })}

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <span className="fw-bold text-black">P&L</span>
            </Accordion.Header>
            <Accordion.Body>Hello P&L</Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {/* <div className="d-flex justify-content-end">
        <Button
          variant="darkblue"
          btncls="px-4"
          type="button"
          disabled={loading || loadingSubmit}
          text={loadingSubmit ? "Saving..." : isEditing ? "Update" : "Submit"}
        />
        </div> */}
      </form>

      <Modal
        show={showSaveAllModal}
        onHide={() => setShowSaveAllModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Save</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to save all vendor purchases to Tally?
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSaveAllModal(false)}
          >
            Cancel
          </Button>

          <Button variant="success" onClick={handleSaveAllPurchases}>
            Yes, Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <div className="mb-3">
            <i
              className="bi bi-check-circle-fill text-success"
              style={{ fontSize: "3rem" }}
            />
          </div>

          <h5>Purchases Saved Successfully!</h5>

          <p className="text-muted mb-0">
            All vendor purchases have been saved to Tally successfully.
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="success" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      {showConfirm && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditing ? "Confirm Update" : "Confirm Purchase Entry"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowConfirm(false)}
                  disabled={loadingSubmit}
                />
              </div>
              <div className="modal-body">
                <p>Are you sure you want to save this purchase entry?</p>
                <p className="mb-0">
                  <strong>Vendors:</strong> {vendors.length} |
                  <strong> Purchase Invoice No:</strong>{" "}
                  {formData.purchase_invoice_number}
                </p>
              </div>
              <div className="modal-footer">
                <Button
                  className="btn btn-secondary"
                  onClick={() => setShowConfirm(false)}
                  disabled={loadingSubmit}
                  text="No"
                />
                <Button
                  className="btn btn-primary"
                  // onClick={confirmSubmit}
                  disabled={loadingSubmit}
                  text={loadingSubmit ? "Saving..." : "Yes, Save"}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Commercial;
